import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutContent from './components/AboutContent';

export default function AboutPage() {
  useSEO({
    title: 'What is CSCF? | Cardiospondylocarpofacial Syndrome Explained — CSCF Support',
    description:
      'Learn about Cardiospondylocarpofacial syndrome (CSCF) — a rare genetic condition caused by MAP3K7 gene variants affecting the heart, skeleton, hearing, and development.',
    keywords:
      'what is CSCF, Cardiospondylocarpofacial syndrome explained, MAP3K7 gene, CSCF symptoms, CSCF diagnosis, rare genetic condition, TAK1 protein, OMIM 157800',
    canonical: 'https://cscfsupport.org/about',
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: 'https://cscfsupport.org/' },
      { name: 'About CSCF', url: 'https://cscfsupport.org/about' },
    ],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'MedicalWebPage',
      name: 'What is Cardiospondylocarpofacial Syndrome (CSCF)?',
      url: 'https://cscfsupport.org/about',
      description:
        'Cardiospondylocarpofacial syndrome (CSCF) is an ultra-rare autosomal dominant genetic condition caused by MAP3K7 gene variants, affecting the heart, skeleton, hearing, and development.',
      about: {
        '@type': 'MedicalCondition',
        name: 'Cardiospondylocarpofacial Syndrome',
        alternateName: ['CSCF', 'CSCFS'],
        code: { '@type': 'MedicalCode', code: '157800', codingSystem: 'OMIM' },
        cause: { '@type': 'MedicalCause', name: 'MAP3K7 gene variants (chromosome 6q15)' },
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <AboutContent />
      <Footer />
    </div>
  );
}
